// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_document_participant_type.ml",
      56,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "DocumentParticipantType"
                    ]]
                },
                "V1"
              ]]
          },
          "$$Document"
        ]]
    });

const $$Document = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_document_participant_type.ml",
      77,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "DocumentParticipantType"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_document_participant_type.ml",
      96,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "DocumentParticipantType"
        ]]
    });

const DocumentParticipantType = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_document_participant_type.ml",
      113,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.document.v1.DocumentParticipantType";
}

function to_int(param) {
  switch (param) {
    case /* DOCUMENT_PARTICIPANT_TYPE_UNSPECIFIED */0 :
        return 0;
    case /* DOCUMENT_PARTICIPANT_TYPE_SENDER */1 :
        return 10;
    case /* DOCUMENT_PARTICIPANT_TYPE_RECIPIENT */2 :
        return 20;
    
  }
}

function from_int_exn(n) {
  if (n !== 0) {
    if (n !== 10) {
      if (n !== 20) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* DOCUMENT_PARTICIPANT_TYPE_RECIPIENT */2;
      }
    } else {
      return /* DOCUMENT_PARTICIPANT_TYPE_SENDER */1;
    }
  } else {
    return /* DOCUMENT_PARTICIPANT_TYPE_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* DOCUMENT_PARTICIPANT_TYPE_UNSPECIFIED */0 :
        return "DOCUMENT_PARTICIPANT_TYPE_UNSPECIFIED";
    case /* DOCUMENT_PARTICIPANT_TYPE_SENDER */1 :
        return "DOCUMENT_PARTICIPANT_TYPE_SENDER";
    case /* DOCUMENT_PARTICIPANT_TYPE_RECIPIENT */2 :
        return "DOCUMENT_PARTICIPANT_TYPE_RECIPIENT";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "DOCUMENT_PARTICIPANT_TYPE_RECIPIENT" :
        return /* DOCUMENT_PARTICIPANT_TYPE_RECIPIENT */2;
    case "DOCUMENT_PARTICIPANT_TYPE_SENDER" :
        return /* DOCUMENT_PARTICIPANT_TYPE_SENDER */1;
    case "DOCUMENT_PARTICIPANT_TYPE_UNSPECIFIED" :
        return /* DOCUMENT_PARTICIPANT_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, DocumentParticipantType, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "DocumentParticipantType"
        ]]
    }, V1, {
      DocumentParticipantType: DocumentParticipantType
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "DocumentParticipantType"
              ]]
          },
          "V1"
        ]]
    }, $$Document, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "DocumentParticipantType"
                    ]]
                },
                "V1"
              ]]
          },
          "$$Document"
        ]]
    }, Buhta, {
      $$Document: $$Document
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
